import React, { useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { Button, Grid } from '@mui/material';
import useProfile from '@/components/_hooks/useProfile';
import { useFormikContext } from 'formik';
import { FormJob } from '@/redux/slices/slice_types';
import SchemaForm from '@/components/_common/SchemaForm/SchemaForm';
import usePrevious from '@/components/_hooks/usePreviousValue';

interface OPOutputVersionsEditProps {
  formValues: FormValues;
  setFormValues: (values: FormValues) => void;
  titleId: string | number;
  titleSchemaFormRef: any;
  primaryVersion?: string;
  onCancel: () => void;
  updateAndSave: () => void;
  setHasChanges: () => void;
}

interface FormValues {
  jobs: FormJob[];
}

const OPOutputVersionsEdit = ({
  formValues,
  setFormValues,
  titleSchemaFormRef,
  titleId,
  primaryVersion,
  onCancel,
  updateAndSave,
  setHasChanges
}: OPOutputVersionsEditProps) => {
  const { values } = useFormikContext<FormValues>();
  const { titleSchema, outputVersionKey } = useProfile(values);
  const prevPrimaryVersion = usePrevious(primaryVersion);
  const prevFormValues = usePrevious(formValues);

  useEffect(() => {
    if (!!prevFormValues && prevFormValues !== formValues) {
      setHasChanges();
    }
  }, [formValues]);

  useEffect(() => {
    if (prevPrimaryVersion && outputVersionKey && prevPrimaryVersion !== primaryVersion) {
      setFormValues({ ...formValues, [outputVersionKey]: '' });
    }
  }, [primaryVersion]);

  const handleSave = () => {
    updateAndSave();
  };
  
  return (
    <Grid container sx={{ mb: 3 }} flexDirection="column">
      {titleSchema.properties && (
        <SchemaForm
          key="edit_schema_form"
          id="edit_schema_form"
          tagName="div"
          formRef={titleSchemaFormRef}
          schema={titleSchema}
          formContext={{ programId: titleId }}
          formData={formValues}
          onChange={(data: any) => setFormValues(data.formData)}
          onError={(errors: any) => console.error(errors)}
        />
      )}
      <Grid item sx={{ mt: 3 }}>
        <LoadingButton variant="outlined" size="small" onClick={handleSave}>
          Save
        </LoadingButton>
        <Button variant="text" color="default" size="small" onClick={onCancel} sx={{ ml: 1 }}>
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
};

export default OPOutputVersionsEdit;
